import { useContext, useState } from 'react';
import { CardDirection, Inputs, Text } from '@taxdown/piccolo-web';
import { history } from 'Store';
import KamiContext from 'Context/KamiContext';
import useScreen, { ScreenAddType } from 'Hooks/useScreen';
import ContentContainer from 'Components/UI/ContentContainer';
import FormContainer from 'Components/UI/FormContainer';
import HeaderInfo from 'Components/HeaderInfo';
import { ScreenPropsType } from 'Types/common';
import ValidationSubmit from '../ValidationSubmit';
import * as Styled from '../../styles';
import HelpInfo from '../HelpInfo';

const AddChildScreen = ({ screenName }: ScreenPropsType): JSX.Element => {
  const { forms } = useContext(KamiContext);
  const { screen, onPrevScreen } = useScreen(screenName) as ScreenAddType;
  const [cardId, setCardId] = useState<string>();
  const [isDataValid, setIsDataValid] = useState(screen.isDataValid());
  const { header, help, subheader, helpButtonUrl } = screen.getRenderForm();

  const goToNextScreen = (): void => {
    const nextScreen = screen.add();
    history.push(forms[nextScreen.id].path, {
      childIndex: nextScreen.index,
    });
  };

  const onChange = (value: string): void => {
    const cardSelected = value === screen.getSelectedOption() ? undefined : value;
    screen.setSelectedOption(cardSelected);
    setCardId(cardSelected);
    setIsDataValid(screen.isDataValid());
  };
  return (
    <ContentContainer testID="add-section">
      <Styled.Container direction="column" fullWidth fullHeight gap="dimension_16">
        <FormContainer>
          <HeaderInfo tag="h4" info={helpButtonUrl} mb="dimension_32">
            {header}
          </HeaderInfo>
          {subheader && (
            <Text type="paragraphs" color="grey" size="S_S_M" mb="dimension_32">
              {subheader}
            </Text>
          )}
          <Inputs.RadioCard
            options={screen?.getOptions().map(option => ({
              ...option,
              direction: CardDirection.VERTICAL,
            }))}
            value={cardId}
            onChange={onChange}
            id="subScreen"
          />
        </FormContainer>
        {help && <HelpInfo info={help} />}
        <ValidationSubmit
          testID="btnSubmit"
          onNextScreen={goToNextScreen}
          onPrevScreen={onPrevScreen}
          disabled={!isDataValid}
        />
      </Styled.Container>
    </ContentContainer>
  );
};

export default AddChildScreen;
